<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67">
		<path d="M33.5,67A33.509,33.509,0,0,1,20.46,2.633,33.508,33.508,0,0,1,46.539,64.367,33.291,33.291,0,0,1,33.5,67ZM39,23a2,2,0,0,0-2,2V42a2,2,0,0,0,4,0V25A2,2,0,0,0,39,23ZM28,23a2,2,0,0,0-2,2V42a2,2,0,1,0,4,0V25A2,2,0,0,0,28,23Z" fill="currentColor"/>
	</svg>
</template>
